import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from './App';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import AccountManagement from './pages/AccountManagement';
import InfluencerLandingPage from './components/InfluencerLandingPage';
import { AdminDashboard, InfluencerManagement } from './pages/admin';

const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/checkout/cancel" element={<CheckoutCancel />} />
      <Route path="/account" element={<AccountManagement />} />
      
      {/* Admin Routes */}
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/influencers" element={<InfluencerManagement />} />
      <Route path="/admin/users" element={<AdminDashboard />} />
      <Route path="/admin/billing" element={<AdminDashboard />} />
      <Route path="/admin/analytics" element={<AdminDashboard />} />
      <Route path="/admin/settings" element={<AdminDashboard />} />
      
      {/* Influencer branded landing pages - must be last to avoid conflicts */}
      <Route path="/:slug" element={<InfluencerLandingPage />} />
    </Routes>
  );
};

export default AppRouter;
